import axios from "axios";
import API_BASE_URL from "./apiConfig";

const API_URL = `${API_BASE_URL}/api`;

const appointmentService = {
  async getAppointments(doctorId) {
    try {
      const url = doctorId 
        ? `${API_URL}/appointments/doctor/${doctorId}`
        : `${API_URL}/appointments`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async getAppointmentById(id, doctorId = null, isAdmin = false) {
    try {
      let url = `${API_URL}/appointments/${id}`;
      const params = new URLSearchParams();
      if (doctorId) params.append('doctorId', doctorId);
      if (isAdmin) params.append('isAdmin', isAdmin);
      if (params.toString()) url += `?${params.toString()}`;
      
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async getAppointmentsByDoctor(doctorId) {
    try {
      const response = await axios.get(
        `${API_URL}/appointments/doctor/${doctorId}`,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async getAppointmentsByPatient(patientId) {
    try {
      const response = await axios.get(
        `${API_URL}/appointments/patient/${patientId}`,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async createAppointment(appointmentData) {
    try {
      const response = await axios.post(
        `${API_URL}/appointments`,
        appointmentData,
      );
      return response.data;
    } catch (error) {
      const errorMsg = error.response?.data?.error || error.message;
      throw new Error(errorMsg);
    }
  },

  async updateAppointment(id, appointmentData) {
    try {
      const response = await axios.put(
        `${API_URL}/appointments/${id}`,
        appointmentData,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async deleteAppointment(id) {
    try {
      const response = await axios.delete(`${API_URL}/appointments/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async searchAppointments(searchQuery, doctorId) {
    try {
      let url = `${API_URL}/appointments/search?q=${encodeURIComponent(searchQuery)}`;
      if (doctorId) {
        url += `&doctorId=${doctorId}`;
      }
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async createPatientWithAppointment(data) {
    try {
      const response = await axios.post(
        `${API_URL}/appointments/create-with-patient`,
        data,
      );
      return response.data;
    } catch (error) {
      const errorMsg = error.response?.data?.error || error.message;
      throw new Error(errorMsg);
    }
  },
};

export default appointmentService;
